import { render } from "./RadarInput.vue?vue&type=template&id=1b509ac4&scoped=true"
import script from "./RadarInput.vue?vue&type=script&lang=js"
export * from "./RadarInput.vue?vue&type=script&lang=js"

import "./RadarInput.vue?vue&type=style&index=0&id=1b509ac4&scoped=true&lang=css"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b509ac4"]])

export default __exports__